import '../styles/components/cart-drawer.css'
import { store } from '../store.js'
import { formatPrice } from '../utils/helpers.js'
import { navigate } from '../router.js'

export function renderCartDrawer(outlet) {
  outlet.innerHTML = `
    <div class="overlay" id="cart-overlay"></div>
    <aside class="cart-drawer" id="cart-drawer" aria-label="Shopping cart">
      <div class="cart-drawer-header">
        <h2 class="cart-drawer-title">Your Cart</h2>
        <button class="cart-close-btn" id="cart-close" aria-label="Close cart">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      <div class="cart-drawer-body" id="cart-body"></div>
      <div class="cart-drawer-footer" id="cart-footer" style="display:none">
        <div class="cart-subtotal">
          <span class="cart-subtotal-label">Subtotal</span>
          <span class="cart-subtotal-value" id="cart-total">$0.00</span>
        </div>
        <button class="btn btn-primary btn-lg cart-checkout-btn" id="cart-checkout-btn">
          Proceed to Checkout
        </button>
        <p class="cart-shipping-note">Shipping calculated at checkout.</p>
      </div>
    </aside>
  `

  const drawer = document.getElementById('cart-drawer')
  const overlay = document.getElementById('cart-overlay')
  const closeBtn = document.getElementById('cart-close')

  closeBtn?.addEventListener('click', () => store.closeCart())
  overlay?.addEventListener('click', () => store.closeCart())

  document.getElementById('cart-checkout-btn')?.addEventListener('click', () => {
    store.closeCart()
    navigate('/checkout')
  })

  // Reactive updates
  store.subscribe('cartOpen', (open) => {
    drawer?.classList.toggle('open', open)
    overlay?.classList.toggle('active', open)
  })

  store.subscribe('cart', (cart) => {
    renderCartItems(cart)
  })
}

function renderCartItems(cart) {
  const body = document.getElementById('cart-body')
  const footer = document.getElementById('cart-footer')
  const totalEl = document.getElementById('cart-total')
  if (!body) return

  if (cart.length === 0) {
    body.innerHTML = `
      <div class="cart-empty">
        <svg class="cart-empty-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 0 0-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 0 0-16.536-1.84M7.5 14.25 5.106 5.272M6 20.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm12.75 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z" />
        </svg>
        <p class="cart-empty-text">Your cart is empty</p>
        <p class="cart-empty-sub">Browse our products and add something.</p>
        <a href="#/shop" class="btn btn-primary" onclick="window.__store?.closeCart()">Shop Now</a>
      </div>
    `
    if (footer) footer.style.display = 'none'
    return
  }

  body.innerHTML = cart.map(item => `
    <div class="cart-item" data-id="${item.id}">
      <div class="cart-item-image">
        ${item.image
          ? `<img src="${item.image}" alt="${escapeHtml(item.name)}" loading="lazy">`
          : `<div style="width:100%;height:100%;background:var(--color-surface)"></div>`
        }
      </div>
      <div class="cart-item-info">
        <div class="cart-item-name">${escapeHtml(item.name)}</div>
        <div class="cart-item-price">${formatPrice(item.price_cents)}</div>
        <div class="cart-qty-control">
          <button class="cart-qty-btn" data-action="dec" data-id="${item.id}">−</button>
          <span class="cart-qty-value">${item.quantity}</span>
          <button class="cart-qty-btn" data-action="inc" data-id="${item.id}">+</button>
        </div>
      </div>
      <button class="cart-item-remove" data-action="remove" data-id="${item.id}" aria-label="Remove ${escapeHtml(item.name)}">✕</button>
    </div>
  `).join('')

  // Footer
  if (footer) {
    footer.style.display = 'block'
    if (totalEl) totalEl.textContent = formatPrice(store.cartTotal)
  }

  // Event delegation for qty controls
  body.addEventListener('click', handleCartAction)
}

function handleCartAction(e) {
  const btn = e.target.closest('[data-action]')
  if (!btn) return
  const id = btn.dataset.id
  const action = btn.dataset.action
  const item = store.get('cart').find(i => i.id === id)
  if (!item) return

  if (action === 'inc') store.updateQuantity(id, item.quantity + 1)
  else if (action === 'dec') store.updateQuantity(id, item.quantity - 1)
  else if (action === 'remove') store.removeFromCart(id)
}

function escapeHtml(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}
